import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.funktionsbereich-detail';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungFunktionsbereichDetailEffects {

    FunktionsbereichDetail$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_FUNKTIONSBEREICH_DETAIL),
        mergeMap((x: ac.GetFunktionsbereichDetailAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getFunktionsbereichDetail(x.funktionsbereich_id).pipe(
                map((result: any) => {
                    return new ac.GetFunktionsbereichDetailErfolgreichAction(result, x.funktionsbereich_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetFunktionsbereichDetailFehlerAction(error, x.funktionsbereich_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunktionsbereicheQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunktionsbereicheQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunktionsbereicheQueryService);
        }
        return this.service;
    }
}
